import { useEffect, useState } from "react";
import { TICKER } from "@/mocks/gua";

const NAV = [
  { label: "新瓜速递", href: "#today" },
  { label: "热门围观", href: "#hot" },
  { label: "合集索引", href: "#collection" },
  { label: "分区速览", href: "#zone" },
  { label: "现场直击", href: "#scene" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setIdx((i) => (i + 1) % TICKER.length), 3200);
    return () => clearInterval(timer);
  }, []);

  const item = TICKER[idx];

  return (
    <header className="sticky top-0 z-40 w-full">
      {/* 导航 */}
      <nav
        className={`w-full transition-colors duration-300 ${
          scrolled ? "bg-[#faf6ef]/90 backdrop-blur border-b border-stone-200/70" : "bg-transparent"
        }`}
      >
        <div className="mx-auto flex w-full items-center justify-between px-4 py-3 md:px-6">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-600 text-white">
              <i className="ri-fire-line text-lg" />
            </span>
            <a href="#top" className="flex items-baseline gap-1 whitespace-nowrap">
              <span className="text-lg font-extrabold tracking-tight text-stone-900">九一吃瓜</span>
              <span className="hidden text-[11px] font-medium text-orange-600 sm:inline">前排围观现场</span>
            </a>
          </div>

          <div className="hidden items-center gap-6 md:flex">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="whitespace-nowrap text-sm text-stone-600 transition hover:text-orange-600"
              >
                {n.label}
              </a>
            ))}
          </div>

          <div className="hidden items-center gap-3 md:flex">
            <span className="flex items-center gap-1.5 whitespace-nowrap text-xs text-stone-500">
              <i className="ri-refresh-line text-orange-600" />
              今日已更新 96 条
            </span>
            <a
              href="#today"
              className="whitespace-nowrap rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-orange-700"
            >
              去前排围观
            </a>
          </div>

          <button
            className="flex h-10 w-10 items-center justify-center rounded-md text-stone-700 md:hidden"
            onClick={() => setOpen((o) => !o)}
            aria-label="打开导航"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-2xl`} />
          </button>
        </div>

        {open && (
          <div className="border-t border-stone-200/70 bg-[#faf6ef] px-4 pb-4 md:hidden">
            <div className="mt-2 flex flex-col gap-1">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-md px-3 py-2 text-sm text-stone-700 transition hover:bg-orange-50 hover:text-orange-600"
                >
                  {n.label}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* 压顶更新条 */}
      <div className="w-full border-b border-orange-200/60 bg-orange-50/80">
        <div className="mx-auto flex w-full items-center gap-3 px-4 py-2 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-bold text-orange-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-500" />
            </span>
            新瓜速递
          </span>
          <span className="hidden h-4 w-px shrink-0 bg-orange-300/70 sm:block" />
          <div className="flex min-w-0 flex-1 items-center gap-3 overflow-hidden">
            <span className="whitespace-nowrap text-[11px] font-semibold text-orange-600">[{item.tag}]</span>
            <p key={idx} className="truncate text-xs text-stone-700">
              {item.text}
            </p>
          </div>
          <span className="shrink-0 whitespace-nowrap text-[11px] text-stone-400">{item.time}前</span>
          <a
            href="#today"
            className="hidden shrink-0 whitespace-nowrap text-[11px] font-medium text-orange-700 sm:inline"
          >
            全部新瓜 <i className="ri-arrow-right-line align-[-1px]" />
          </a>
        </div>
      </div>
    </header>
  );
}